module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-13.ff45a077.JPG";